"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformRESTBytesToSDKBytes = exports.transformSDKBytesToRESTBytes = void 0;
function transformSDKBytesToRESTBytes(val) {
    const chars = val.reduce((res, c) => res + String.fromCharCode(c), '');
    return btoa(chars);
}
exports.transformSDKBytesToRESTBytes = transformSDKBytesToRESTBytes;
function transformRESTBytesToSDKBytes(val) {
    return Uint8Array.from(atob(val), (c) => c.charCodeAt(0));
}
exports.transformRESTBytesToSDKBytes = transformRESTBytesToSDKBytes;
